<template lang="pug">
  div
    filter-table(
      layout="text, date"
      :rowSelectedCount="rowsSelected"
      @inputSearchFilter="inputSearchFilter"
      @resetDateFilter="resetDateFilter"
      @paramsDateFilter="paramsDateFilter")
    .credits-table.ods-mt-6
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        :data='tableDataRendered'
        :default-sort = "{prop: 'fremesa', order: 'descending'}"
        @selection-change="handleSelectionChange"
        )
        ods-table-column(type='selection' width='55')
        ods-table-column(prop='fecrem' label='Fecha remesa' sortable)
          template(slot-scope="scope")
            div {{ scope.row.fecrem | formatDateLocale }}
        ods-table-column(prop='numrefrem' label='Referencia' sortable)
        ods-table-column(prop='destiporem' label='Tipo' sortable)
        ods-table-column(prop='numfac' label='Nº Operaciones' sortable)
        ods-table-column(prop='impnom' label='Nominal' sortable)
          template(slot-scope="scope")
            div {{ scope.row.impnom | toCurrencyCode(scope.row.clamon) }}
        ods-table-column(prop='impdes' label='Descuento' sortable)
          template(slot-scope="scope")
            div {{ scope.row.impdes | toCurrencyCode(scope.row.clamon) }}
        ods-table-column(prop='dessitrem' label='Estado' sortable width="200" class-name="cell-tag")
          template(slot-scope="scope")
            ods-tag(:type="getType(scope.row.dessitrem)") {{ scope.row.dessitrem }}
        ods-table-column(prop='fecabono' label='Fecha de abono' sortable)
          template(slot-scope="scope")
            div {{ scope.row.fecabono | formatDateLocale }}
        ods-table-column(prop='acciones' label='acciones' class-name="cell-actions")
          template(slot-scope="scope")
            ods-actions-menu(
              customClass="card-menu"
              icon="overflow-menu"
              color="#888A91"
              size="18"
              popoverPosition="bottom-end")
              ul.menu
                li.menu__item
                  a(href="#" @click.prevent="goToDetailFactura(scope.row)") Ver facturas
                li.menu__item
                  a(href="#" @click.prevent="goToDetailRecibo(scope.row)") Ver recibos

      div.footer
        paginator(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
        //- ods-pagination.footer__page(
        //- :page-sizes='[5, 10, 50, 100]',
        //- :page-size="itemsPerPage",
        //- layout='prev, next',
        //- :total='totalData'
        //- @size-change='handleSizeChange',
        //- @current-change='handleCurrentChange'
        //- style="text-align: right; margin-top: 20px")

</template>

<script>
import { mapGetters } from 'vuex'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'BillingTable',

  components: {
    FilterTable,
    Paginator
  },

  props: {
    comercio: {
      required: true
    }
  },

  data () {
    return {
      defaultParams: { codcom: this.comercio.codcom },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      rowsSelected: null
    }
  },

  computed: {
    ...mapGetters([
      // 'itemsPerPage'
    ])
  },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado de Consultas - Facturación
      await this.$store.dispatch('listBilling', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter((res) => {
        return res.destiporem.toLowerCase().includes(text.toLowerCase()) ||
        res.numrefrem.toString().toLowerCase().includes(text.toString().replace(',', '.').toLowerCase()) ||
        res.impnom.toString().toLowerCase().includes(text.toString().replace(',', '.').toLowerCase())
      })
    },

    paramsDateFilter (val) {
      const params = {
        ...this.defaultParams,
        ...val
      }
      this.getData(params)
    },

    resetDateFilter () {
      this.getInitialData()
    },

    handleSelectionChange (val) {
      this.rowsSelected = val.length
    },

    goToDetailFactura (val) {
      this.$router.push({
        name: 'FacturacionTable',
        params: {
          numrefrem: val.numrefrem,
          comercio: this.comercio
        }
      })
    },

    goToDetailRecibo (val) {
      this.$router.push({
        name: 'RecibosTable',
        params: {
          codproceso: 1,
          numrefrem: val.numrefrem,
          comercio: this.comercio
        }
      })
    },

    getType (row) {
      return row === 'FINALIZADA' ? 'success' : 'warning'
    }
  },

  mounted () {
    this.getInitialData()
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}
</style>
